export const theme = {
	dark: {
		background: '#FFFFFF',
		title: 'black',
		para: '#233742',
		heading: '#233742',
		line: 'white',
		imgBackground: 'white',
		highlightBackground: '#FFFFE0',
		sideIcons: '#766161',
		menuBackground: '#aaeff8',
		card: '#8BD8CE',
		linkHover: 'linear-gradient(135deg, white, #6fd8c1)',
	},
	light: {
		background: '#FFFFFF',
		title: 'black',
		para: '#233742',
		heading: '#233742',
		line: 'white',
		imgBackground: 'white',
		highlightBackground: '#FFFFE0',
		sideIcons: '#766161',
		menuBackground: '#aaeff8',
		card: '#8BD8CE',
		linkHover: 'linear-gradient(135deg, white, #6fd8c1)',
	},
};
